export const getFormattedSupportersLabel = (supporters) => {
    const amount = new Intl.NumberFormat('en-US').format(Number(supporters || 0));
    return `${amount}\u00A0supporters`;
};
